module.exports = __webpack_public_path__ + "static/media/accreditation-required-logo.5862dc21.svg";